export default __webpack_public_path__ + "static/media/sqlite.913f7f7e.svg";